import { render, staticRenderFns } from "./UserWalletTransactionForm.vue?vue&type=template&id=7ef53e33&"
import script from "./UserWalletTransactionForm.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports